export { default as PeoplePickerDialog } from './components/PeoplePickerDialog';
